import { createSlice } from "@reduxjs/toolkit";
import { createEmailTemplateAPI } from "../../services/createEmailTemplate";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const createEmailTemplateSlice = createSlice({
  name: "createEmailTemplate",
  initialState: data,
  reducers: {
    createEmailTemplateInfo(state) {
      state.isLoading = true;
    },
    createEmailTemplateSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    createEmailTemplateFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    createEmailTemplateReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const createEmailTemplateHandler =
  (data, options = {}) =>
  async (dispatch) => {
  try {
    dispatch(createEmailTemplateAction.createEmailTemplateInfo());
    const response = await createEmailTemplateAPI(data, options);
    dispatch(createEmailTemplateAction.createEmailTemplateSuccess(response));
  } catch (e) {
    const failurePayload =
      e && typeof e === "object" && "message" in e
        ? e
        : { message: e || "Something went wrong." };
    dispatch(createEmailTemplateAction.createEmailTemplateFailure(failurePayload));
  }
};
export default createEmailTemplateSlice.reducer;
export const createEmailTemplateAction = createEmailTemplateSlice.actions;
